import { UserSagas } from './common/CommonSagas';

export default [...UserSagas];
